import { Header } from '../../components/layout';
import { Sidebar } from '../../components/layout/Sidebar';
import {
  FiBarChart2, FiFileText, FiList,
  FiMinusCircle, FiPlusCircle, FiTrendingUp,
} from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts';
import { usePreferences } from '../../contexts/PreferencesContext';
import type { PermissionAction, PermissionModule } from '../../types';
import styles from './Home.module.css';

export function Home() {
  const navigate = useNavigate();
  const { user, canAccess, hasPermission } = useAuth();
  const { t } = usePreferences();
  const firstName = user?.name?.split(' ')[0] || 'Usuário';

  const allCards: { labelKey: string; icon: typeof FiPlusCircle; path: string; accent: string | null; highlightKey: string | null; permissionModule: PermissionModule; permissionAction?: PermissionAction }[] = [
    { labelKey: 'home.lancar', icon: FiPlusCircle, path: '/lancar-receita', accent: 'receitas', highlightKey: 'home.receitas', permissionModule: 'LANCAMENTOS', permissionAction: 'CREATE' },
    { labelKey: 'home.lancar', icon: FiMinusCircle, path: '/lancar-despesa', accent: 'despesas', highlightKey: 'home.despesas', permissionModule: 'LANCAMENTOS', permissionAction: 'CREATE' },
    { labelKey: 'home.historico', icon: FiList, path: '/lancamentos', accent: null, highlightKey: null, permissionModule: 'LANCAMENTOS' },
    { labelKey: 'home.cashflow', icon: FiTrendingUp, path: '/cashflow', accent: null, highlightKey: null, permissionModule: 'FLUXO_CAIXA' },
    { labelKey: 'home.graficos', icon: FiBarChart2, path: '/graficos', accent: null, highlightKey: null, permissionModule: 'DASHBOARD' },
    { labelKey: 'home.relatorios', icon: FiFileText, path: '/reports', accent: null, highlightKey: null, permissionModule: 'RELATORIOS' },
  ];
  const cards = allCards.filter((card) => canAccess(card.path) && hasPermission(card.permissionModule, card.permissionAction ?? 'VIEW'));
  // Com 4 cartoes a grade de 3 colunas deixava um buraco na segunda linha.
  // Com 4, duas linhas cheias.
  const gridClass = cards.length === 4 ? `${styles.grid} ${styles.gridQuatro}` : styles.grid;

  return (
    <div className={styles.layout}>
      <Sidebar />
      <main className={styles.main}>
        <Header title={t('home.titulo')} />
        <div className={styles.content}>
          <h2 className={styles.greeting}>{t('home.saudacao', { name: firstName })}</h2>

          <div className={gridClass}>
            {cards.map((card, i) => (
              <button
                key={i}
                className={styles.card}
                onClick={() => navigate(card.path)}
              >
                <card.icon size={48} className={styles.cardIcon} />
                <span className={styles.cardLabel}>
                  {card.accent && card.highlightKey ? (
                    <>
                      {t(card.labelKey)}{' '}
                      <span className={styles[card.accent]}>{t(card.highlightKey)}</span>
                    </>
                  ) : t(card.labelKey)}
                </span>
              </button>
            ))}
          </div>

        </div>
      </main>
    </div>
  );
}